export const USER_IN_PROCESS = 'USER_IN_PROCESS';
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_FETCH = "USER_FETCH";
export const USER_ONLINE = "USER_ONLINE";
export const USER_OFFLINE = "USER_OFFLINE";
export const USER_PASSWORD_REQUEST = "USER_PASSWORD_REQUEST";
export const USER_PASSWORD_NEW = "USER_PASSWORD_NEW";
export const USER_SIGNUP = "USER_SIGNUP";
export const USER_OVERLAY_OPEN = "USER_OVERLAY_OPEN";
export const USER_DELETE = 'USER_DELETE';
export const USER_SET_MODE = 'USER_SET_MODE';
